<template>
  <div class="header"> 
    <div class="logo" v-show="device!=='mobile'" >
      <span class="h1" style="letter-spacing:4px;">{{esatename}}</span> 
    </div>
    <div class="right-menu">
      <div class="system"  @click="goto(-1,'/monitor')" v-show="levelId==2 && userRemoteMenuIds.indexOf(156)!==-1">
        <div><img src="/static/icon/monitorsys.png" style="height:30px;width:30px"/></div>
        <div  v-show="device!=='mobile'" >设备监控</div>
      </div>
      <div class="system" @click="goto(0)" v-show="userRemoteMenuIds.indexOf(65)!==-1">
        <div><img src="/static/icon/usersys.png" style="height:30px;width:30px"/></div>
        <div  v-show="device!=='mobile'" >用户中心</div>
      </div>
      <div class="system"  @click="goto(2)" v-show="userRemoteMenuIds.indexOf(22)!==-1">
        <div><img src="/static/icon/doorsys.png" style="height:30px;width:30px"/></div>
        <div  v-show="device!=='mobile'" >门禁系统</div>
      </div>
      <div class="system"  @click="goto(1)" v-show="userRemoteMenuIds.indexOf(47)!==-1">
        <div><img src="/static/icon/liftsys.png" style="height:30px;width:30px"/></div>
        <div  v-show="device!=='mobile'" >梯控系统</div>
      </div>
      <div class="system"  @click="goto(5)" v-show="userRemoteMenuIds.indexOf(131)!==-1">
        <div><img src="/static/icon/talkbacksys.png" style="height:30px;width:30px"/></div>
        <div  v-show="device!=='mobile'" >楼宇对讲</div>
      </div>
      <div class="system"  @click="goto(4)"  v-show="userRemoteMenuIds.indexOf(66)!==-1">
        <div><img src="/static/icon/visitorsys.png" style="height:30px;width:30px"/></div>
        <div  v-show="device!=='mobile'" >访客系统</div>
      </div>
      <div class="system" @click="goto(6)"   v-show="userRemoteMenuIds.indexOf(171)!==-1">
        <div><img src="/static/icon/worksys.png" style="height:30px;width:30px"/></div>
        <div  v-show="device!=='mobile'" >考勤系统</div>
      </div>
      <div class="system" style="margin-right:40px;"  @click="goto(-1)"   v-show="userRemoteMenuIds.indexOf(136)!==-1">
        <div><img src="/static/icon/parksys.png" style="height:30px;width:30px"/></div>
        <div  v-show="device!=='mobile'" >停车场系统</div>
      </div>
      <div class="system" @click="goto(7)"   v-show="userRemoteMenuIds.indexOf(214)!==-1">
        <div><img src="/static/icon/cardsys.png" style="height:30px;width:30px"/></div>
        <div  v-show="device!=='mobile'" >消费卡系统</div>
      </div>
      <template v-if="device!=='mobile'">
        <!-- <error-log class="errLog-container right-menu-item"/> -->
        <!-- <websocket class=""  /> -->
        <el-tooltip :content="$t('navbar.screenfull')" effect="dark" placement="bottom">
          <screenfull class="screenfull right-menu-item"/>
        </el-tooltip>

        <!-- <el-tooltip :content="$t('navbar.size')" effect="dark" placement="bottom">
          <size-select class="international right-menu-item"/>
        </el-tooltip>   -->
      </template>

      <div class="right-menu"> 
        <el-dropdown class="avatar-container right-menu-item" trigger="click">
          <div class="avatar-wrapper" style="display: flex;line-height:50px;">
            <div>
              <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar" style="height:36px;width: 36px;">
            </div>
            <div style="margin:-6px 4px 0px 4px;">|</div>
            <div style="display:block;cursor:pointer;margin-top:-6px;" @click="logout">{{ $t('header.logOut') }}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item >
              <span>账号:<span style="color:blue;">{{logincode}}</span></span>
            </el-dropdown-item>
            <el-dropdown-item  @click.native.prevent="doChangePwd">
              <span >修改密码</span>
            </el-dropdown-item>
          </el-dropdown-menu> 
        </el-dropdown>
      </div>  

    <el-dialog
      custom-class="inputDialog"
      :close-on-click-modal="false"
      ref="dialog"
      title="修改密码"
      :visible.sync="showDialog.changepwd"
      append-to-body
      width="600px"
      v-if="showDialog.changepwd"
    >
     <ChangePwd :showdialog.sync="showDialog.changepwd"/>
    </el-dialog>
  
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb' 
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import LangSelect from '@/components/LangSelect'
import ThemePicker from '@/components/ThemePicker'
import Websocket from '@/components/Websocket'
import ChangePwd from './ChangePwd' 
import {getLoginCode, getEstateName, getLevelId} from '@/utils/auth'
 
export default {
  components: {
    ChangePwd,
    Breadcrumb, 
    ErrorLog,
    Screenfull,
    SizeSelect,
    LangSelect,
    ThemePicker,
    Websocket
  },
  data() {
    return { 
      showDialog: {changepwd: false},
      logincode: getLoginCode(),
      esatename: getEstateName(),
      levelId: getLevelId(),
      menus: this.$router.options.routes
    }
  },
  computed: {
    ...mapGetters([
      'name',
      'avatar',
      'device',
      'userRemoteMenuIds'
    ])
  },
  methods: { 
    doChangePwd() {
      this.showDialog.changepwd = true;
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push('/login')
       // location.reload()// In order to re-instantiate the vue-router object to avoid bugs
      })
    },
    goto(system, url) { 
      if (url !== undefined && url === '/park') {
        this.$message.info("开发中...");
        return false;
      }
      if (url !== undefined) {
        this.$router.push(url); 
      }
      if (system > -1) { 
        this.$store.dispatch('setCurSystem', {system: system});
        // console.log(this.menus)
        // console.log('system:' + system + ' url:' + url)
        // 循环menus获取第一个交集菜单
        for (let i = 0; i < this.menus.length; i++) {
          if (this.menus[i].systemtypeid !== undefined && this.menus[i].systemtypeid === system && this.menus[i].children.length > 0) {
              if (this.userRemoteMenuIds.indexOf(this.menus[i].children[0].menuid) !== -1) { 
                this.$router.push({name: this.menus[i].children[0].name}); 
                break;
              }
          } 
        } 
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

.logo {
  line-height: 80px;
  z-index: 1;
}

.logo .h1 {
  height: 58px;
  font-size: 24px;
  line-height: 58px;
  padding-left: 24px;
  color: #fff;
} 

.system{
  font-size: 14px;
  margin:0px 14px;
  color:#fff;
  text-align: center;
  cursor: pointer;
}
.header {
  display: flex;
  justify-content: space-between;
  height: 80px;
  background-color: #1f2d3d;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .breadcrumb-container{
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .right-menu {
    display:flex;
    align-items: center;
    float: right;
    height: 100%;
    z-index: 9;
    &:focus{
     outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }
    .websocket {
      height: 20px;
    }
    .screenfull {
      height: 20px;
    }
    .international{
      vertical-align: top;
    }
    .theme-switch {
      vertical-align: 15px;
    }
    .avatar-container {
      height: 50px;
      margin-right: 30px;
      color: #fff;
      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/SysHeader.vue